import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { LookupCarreras } from '../Carreras/LookupCarreras';

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class InscribirAlumno extends Component {
  static displayName = InscribirAlumno.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dni: '',
      name: '',
      errorMessage: '',
      successMessage: '',
      tagData: [],
      showLookupCarreras: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    constantClass.canAccess('WWAlumnosxCarrera');
  }

  clearFeedback() {
    if (this.state.errorMessage || this.state.successMessage) {
      this.setState({ errorMessage: '', successMessage: '' });
    }
  }

  handleDNIChangeInput = (e) => {
    this.clearFeedback();
    this.setState({ dni: e.target.value });
  };

  handleNameChangeInput = (e) => {
    this.clearFeedback();
    this.setState({ name: e.target.value });
  };

  handleHideLookup = () => {
    this.setState({ showLookupCarreras: false });
  };

  handleSelectCarreraItem = (e) => {
    const carreraProperties = e.split('%');
    const tag = { id: carreraProperties[0], text: carreraProperties[1] };
    this.clearFeedback();
    this.setState((prev) => ({
      showLookupCarreras: false,
      tagData: prev.tagData.some((t) => t.id === tag.id) ? prev.tagData : [...prev.tagData, tag],
    }));
  };

  handleShowCarreraLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupCarreras: true });
    }
  };

  handleDeleteTag = (id) => {
    this.clearFeedback();
    this.setState((prev) => ({ tagData: prev.tagData.filter((tag) => tag.id !== id) }));
  };

  handleReset = () => {
    this.setState({
      dni: '',
      name: '',
      tagData: [],
      errorMessage: '',
      successMessage: '',
      showLookupCarreras: false,
    });
  };

  isFormValid() {
    return (
      this.state.dni.trim().length > 0 &&
      this.state.name.trim().length > 0 &&
      this.state.tagData.length > 0
    );
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) return;
    if (!this.isFormValid()) {
      this.setState({
        errorMessage: 'Complete DNI, nombre y seleccione al menos una carrera.',
      });
      return;
    }
    this.saveRecord();
  }

  async saveRecord() {
    if (isSubmitInProgress(this.state.loading)) return;

    const carrerasCod = this.state.tagData.map((tag) => parseInt(tag.id, 10));
    const dni = this.state.dni.trim();
    const name = this.state.name.trim();

    this.setState({ loading: true, errorMessage: '', successMessage: '' });

    const { data } = await constantClass.apiFetch('api/axc/inscribir', {
      method: 'POST',
      body: JSON.stringify({
        AlumnoNombre: name,
        AlumnoDni: dni,
        CarrerasCod: carrerasCod,
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || data.returnModel === false) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo inscribir al alumno. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({
      loading: false,
      successMessage: 'El alumno se inscribió correctamente.',
      dni: '',
      name: '',
      tagData: [],
      showLookupCarreras: false,
    });
  }

  renderCareerTags() {
    const { tagData, loading } = this.state;
    if (tagData.length === 0) {
      return <p className="md-form-page__empty-hint">Ninguna carrera seleccionada</p>;
    }
    return (
      <ul className="md-form-page__tags">
        {tagData.map((tag) => (
          <li key={tag.id} className="md-form-page__tag">
            <span>{tag.text}</span>
            <button
              type="button"
              className="md-form-page__tag-remove"
              onClick={() => this.handleDeleteTag(tag.id)}
              disabled={loading}
              aria-label={'Quitar ' + tag.text}
            >
              ×
            </button>
          </li>
        ))}
      </ul>
    );
  }

  render() {
    const { loading, errorMessage, successMessage, dni, name, showLookupCarreras } = this.state;
    const isBusy = loading;

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-axc">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Inscribir alumno</h1>
        <p className="md-form-page__subtitle">
          Registre un alumno nuevo y asígnelo a una o más carreras.
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {successMessage ? <span className="md-form-page__success">{successMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Procesando inscripción, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="inscribir-dni">
                Documento de Identidad
              </label>
              <input
                id="inscribir-dni"
                className="md-form-page__input"
                type="text"
                placeholder="Ingrese DNI"
                value={dni}
                onChange={this.handleDNIChangeInput}
                disabled={isBusy}
                required
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="inscribir-nombre">
                Nombre Completo
              </label>
              <input
                id="inscribir-nombre"
                className="md-form-page__input"
                type="text"
                placeholder="Ingrese nombre y apellido"
                value={name}
                onChange={this.handleNameChangeInput}
                disabled={isBusy}
                required
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Carreras</span>
              <button
                type="button"
                className="md-form-page__pick-btn"
                onClick={this.handleShowCarreraLookup}
                disabled={isBusy}
              >
                Seleccione la Carrera
              </button>
              {showLookupCarreras ? (
                <LookupCarreras selectItem={this.handleSelectCarreraItem} hideLookup={this.handleHideLookup} />
              ) : null}
              {this.renderCareerTags()}
            </div>

            <div className="md-form-page__actions">
              <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                Confirmar inscripción
              </button>
              <button
                type="button"
                className="md-form-page__btn md-form-page__btn--secondary"
                onClick={this.handleReset}
                disabled={isBusy}
              >
                Limpiar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
